import getFormSession from "../../../Components/CluppForms/getFormSession";
import fetchApplyDiscount from "../../../Services/users/fetchApplyDiscount";
import { getProductData } from "../../../utils/getUserUtility";
import AceptDiscount from "./AceptDiscount";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { differenceInMonths } from "date-fns";
import abandonCancelation from "../abandonCancelation";

const landingId = "CF_ACEPT_DISCOUNT";

function formatDateFromTimestamp(timestamp) {
  const date = new Date(timestamp);

  const day = date.getUTCDate();
  const year = date.getFullYear();

  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const month = months[date.getUTCMonth()];

  return `${day} de ${month} ${year}`;
}

const onLoad = async ({
  session,
  landedAt,
  uid,
  fieldsStructure,
  navigate,
}) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const lastLanding = landings[landings.length - 1];
  const lastLandingMetadata = lastLanding.metadata;

  const { pid, pType } = lastLandingMetadata;
  const periods = {
    month: "mensual",
    "3month": "trimestral",
    "6month": "semestral",
    year: "anual",
  };

  try {
    let haveAnActiveDiscount = false;
    const productData = await getProductData(uid, { id: pid, type: pType });

    const userRef = doc(db, `users/${uid}`);
    const userSnap = await getDoc(userRef);
    let aceptedDate

    if (userSnap.exists()) {
      const { cancelationDiscountAcceptedAt } = userSnap.data();
      aceptedDate = cancelationDiscountAcceptedAt
      if (cancelationDiscountAcceptedAt) {
        const discountDate = new Date(cancelationDiscountAcceptedAt);
        const currentDate = new Date();

        const monthsDifference = differenceInMonths(currentDate, discountDate);

        if (monthsDifference <= 1) {
          haveAnActiveDiscount = true;
        }
      }
    }

    if (!haveAnActiveDiscount) {
      const response = await fetchApplyDiscount({
        uid,
        productId: pid,
        productType: pType,
      });

      const {
        prevPremium,
        newPremium,
        nextPaymentAmount,
        nextPaymentDate,
        discountApplied,
      } = response;

      await updateDoc(userRef, {
        cancelationDiscountAcceptedAt: Date.now(),
      });

      const nextPayment = nextPaymentDate
        ? formatDateFromTimestamp(nextPaymentDate)
        : null;

      const state = {
        userId: uid,
        premium: prevPremium,
        premiumWithDiscount: newPremium,
        nextPaymentAmount,
        discount: discountApplied * 100,
        nextPayment,
        period: periods[productData.period],
        ...prevAnswers,
        landedAt,
        prevForm,
        currentLanding: landingId,
        haveAnActiveDiscount,
      };

      await abandonCancelation({
        session,
        state,
        uid,
      });

      return state;
    } else {
      return {
        userId: uid,
        haveAnActiveDiscount,
        cancelationDiscountAcceptedAt: formatDateFromTimestamp(
          aceptedDate
        ),
        period: periods[productData.period],
        ...prevAnswers,
        landedAt,
        prevForm,
        currentLanding: landingId,
      };
    }
  } catch (err) {
    console.log(`Ocurrio un error inesperado en al landing: ${landingId}`, err);
    navigate(`/formulario/cancelacion/error?uid=${uid}`);
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {};

const content = ({ state, setState }) => (
  <AceptDiscount state={state} /> // Field ID
);

const nextPage = (props) => ``;
const prevPage = (props) => ``;

const fieldsStructure = [];

const aceptDiscountProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default aceptDiscountProps;
